import { Injectable } from "@angular/core";
import { Adapter } from "./adapter"
import { Skill } from "./skill";
import { Role } from "./role";
import { People, PeopleAdapter } from "./people";
import { ITeamRoleRequirement } from "../_interfaces/teamRoleRequirement";

export class Team {
    
    public peoples: People[] = [];

    constructor(
        public id: number = 0 ,
        public name: string = '', 
        public description: string = '', 
        public createdAt: Date = new Date(), 
        public updatedAt: Date | null = null,
        public skills: Skill[] = [],
        public roles: ITeamRoleRequirement[] =[],
        public teamType: string = '',
        public manager: People | null = null
        ) {}
}

@Injectable({
    providedIn: "root",
})
export class TeamAdapter implements Adapter<Team> {

    constructor(private peopleAdapter: PeopleAdapter) { }

    adapt(item: any): Team {

        let skills: Skill[] = [];
        if (item.skills) {  
            skills = item.skills.map((skill: any) => new Skill(
                skill.id,
                skill.name,
                skill.description,
                new Date(skill.created_at),
                new Date(skill.updated_at),
            ));
        }

        let roles: ITeamRoleRequirement[] = [];
        if (item.roles) {
            roles = item.roles.map((roleRequirement: any) => ({
                role: new Role( 
                    roleRequirement.role.id,
                    roleRequirement.role.name,
                    roleRequirement.role.description,
                    new Date(roleRequirement.role.created_at),
                    new Date(roleRequirement.role.updated_at)
                ),
                required_fte: roleRequirement.required_fte 
            }));
        }

        

        const updatedAt = item.updated_at ? new Date(item.updated_at) : null;
        
        const team = new Team(item.id, item.name, item.description, new Date(item.created_at), updatedAt, skills, roles, item.team_type);
        
        if(item.peoples) {
            team.peoples = item.peoples.map(
                (people: any)  => this.peopleAdapter.adapt(people)
            );
        }

        if (item.manager) {
            team.manager = this.peopleAdapter.adapt(item.manager);
        }

        return team 
    }

    adaptToApi(team: Team): any {
        
        return {
            id: team.id,
            name: team.name,
            description: team.description,
            team_type: team.teamType,
            created_at: team.createdAt,
            updated_at: team.updatedAt,
            manager: team.manager ? {id: team.manager.id} : null,
            skills:team.skills.map(skill => ({
                id: skill.id,
                name: skill.name,
                description: skill.description,
                created_at: skill.createdAt,
                updated_at: skill.updatedAt
            })),
                roles: team.roles.map(teamRoleRequirement => ({ 
                id: teamRoleRequirement.role.id, 
                required_fte: teamRoleRequirement.required_fte 
            }))
        }
    }
}